import {html} from "lit";
import {customElement} from "lit/decorators/custom-element.js";
import {property} from "lit/decorators/property.js";
import {when} from "lit/directives/when.js";
import {UuidHelper} from "../../../helpers/uuid.helper";
import {AbstractInputComponent} from "../abstract-input.component";

@customElement(`ha-input-checkbox`)
export class HaInputCheckboxComponent extends AbstractInputComponent {

    private _id = UuidHelper.generateV7();

    private _states: [any, any] = [false, true];

    @property({type: Boolean, attribute: `is-toggle`})
    public isToggle = false;

    @property({type: Array})
    public get states(): [any, any] {
        return this._states;
    }

    public set states(_states: [any, any]) {
        if (!(Array.isArray(_states) && _states.length === 2 && _states[0] !== _states[1])) {
            console.error(`for component with id ${this._id} are not an array with two values.`);
            return;
        }
        const oldValue = this._states;
        this._states = _states;
        this.requestUpdate(`states`, oldValue);
    }

    private _value: any = false;

    @property({type: Object})
    public get value(): any {
        return this._value;
    }

    public set value(value: any) {
        if (!this._states.includes(value)) {
            console.error(`for component with id ${this._id} was tried to set value to ${JSON.stringify(value)}, but it is not an allowed one.`);
            return;
        }
        const oldValue = this._value;
        this._value = value;
        this.requestUpdate(`value`, oldValue);
    }

    private get _isChecked(): boolean {
        return this._value === this._states[1];
    }

    protected render(): unknown {
        return html`
            <input id=${this._id}
                   type="checkbox"
                   .checked=${this._isChecked}
                   ?disabled=${this.readonly}
                   @input=${this._onInput}>
            ${when(this.isToggle, () => html`
                <label class="toggle" for=${this._id}></label>
            `)}
            ${when(this.label, () => html`
                <div class="label" for=${this._id}>${this.label}</div>
            `)}
            ${this._renderHelperText()}
            ${this._renderErrors()}
        `;
    }

    private _onInput(evt: Event): void {
        if (this.readonly) {
            return;
        }

        const checkedIndex = (evt.target as HTMLInputElement).checked ? 1 : 0;

        this.value = this._states[checkedIndex];

        this.dispatchEvent(
            new CustomEvent<{ value: boolean }>(`value-changed`, {detail: {value: this.value}})
        );
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'ha-input-checkbox': HaInputCheckboxComponent;
    }
}